module.exports = __webpack_public_path__ + "img/toggle-list.6973096f.svg";